import React, { useState } from "react";

import IconMan from './img/man'
import IconWoman from './img/woman'

const RadioButton = (props) => {
	const { value, checked, id } = props

	return <>
		<label className={`radioButton ${checked ? 'selected' : ''}`}>
			<input type="radio" id={id} {...props} />
			{value === 0 ? <IconMan /> : <IconWoman />}
			<span>{value === 0 ? 'ذكـر' : 'أنثى'}</span>
		</label>
	</>
}
export default RadioButton